import type { SerialAssignment } from '../../domain/shipment';

export function SerialSourceBadge({
  source,
  confidence,
}: Pick<SerialAssignment, 'source' | 'confidence'>) {
  if (source === 'HEARTBEAT_INFERENCE') {
    return (
      <span className="state-badge evidence-badge-inferred">
        {confidence === 'UNCONFIRMED'
          ? 'Inferred from heartbeat · unconfirmed'
          : 'Inferred from heartbeat'}
      </span>
    );
  }
  return <span className="state-badge state-badge-ready">Entered</span>;
}
